import { render, staticRenderFns } from "./Aboutwe.vue?vue&type=template&id=ecd2eacc&scoped=true&"
import script from "./Aboutwe.vue?vue&type=script&lang=js&"
export * from "./Aboutwe.vue?vue&type=script&lang=js&"
import style0 from "./Aboutwe.vue?vue&type=style&index=0&id=ecd2eacc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd2eacc",
  null
  
)

export default component.exports